<template>
    <div class="column user-dashboard" :style="panelStyles">
        <theme-scene :theme="theme" />
        <profile-customizer :overlay-styles="overlayStyles" />
    </div>
</template>

<script>
import themedPanel from '../../mixins/themedPanel.js'

import ProfileCustomizer from './ProfileCustomizer.vue'
import ThemeScene from './ThemeScene.vue'

/**
 * `/profile/:id/customize` — the same frame as the Stats panel, around the
 * picker.
 *
 * Reaching it on someone else's profile is refused by the router (see the
 * `beforeEnter` on the route), not by this component: a panel that renders
 * nothing is a blank page, whereas a redirect puts you somewhere real.
 */
export default {
    name: 'ProfileCustomizePanel',
    components: { ProfileCustomizer, ThemeScene },
    mixins: [themedPanel],
}
</script>
